import Vue from 'vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';

let instance;

function initInstance() {
  const LoadingConstructor = Vue.extend(LoadingOverlay);
  instance = new LoadingConstructor();
  instance.$mount(document.createElement('div'));
  document.body.appendChild(instance.$el);
}

export function showLoading(customText) {
  if (!instance) {
    initInstance();
  }
  instance.show(customText);
}

export function hideLoading() {
  if (instance) {
    instance.hide();
  }
}
